import styled from 'styled-components';
import { ColorAddiGrayBase } from '@addi/foundation/dist/web/colors';
import { FontAddiWeightBold, FontAddiWeightRegular, FontAddiWeightSemiBold, } from '@addi/foundation/dist/web/fonts';
import { SizeAddiFontSmall, SizeAddiFontXSmall, SizeAddiFontXxSmall, SizeAddiFontBase, } from '@addi/foundation/dist/web/sizes';
import { LayoutAddiScreenMobileLargeMax } from '@addi/foundation/dist/web/layout';
import { Header1, Header3, Paragraph } from '../../components/typographies';
const defaultImage = 'https://statics.addi.com/ui-storybook/default-store-logo.png';
export const ItemContainer = styled.div `
  padding: 0;
  display: inline-block;
  width: 100%;
`;
export const ImageContainer = styled.div `
  min-width: 156px;
  width: ${({ fixedSize }) => (fixedSize ? '156px' : '100%')};
  height: 100%;
  aspect-ratio: 16/8.1;
  border-radius: 12px;
  background-image: ${({ backgroundImage }) => backgroundImage
    ? `image-set(
      url(${backgroundImage}?format=auto&width=200) 1x,
      url(${backgroundImage}?format=auto&width=400) 2x,
      url(${backgroundImage}?format=auto&width=600) 3x)`
    : `url(${defaultImage})`};
  background-color: transparent;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  box-shadow: 0px 4px 12px rgba(86, 90, 97, 0.12);
  cursor: pointer;

  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    min-width: 232px;
    width: ${({ fixedSize }) => (fixedSize ? '232px' : '100%')};
    aspect-ratio: 24/16.2;
  }

  @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 144dpi) {
    background-image: ${({ backgroundImage }) => backgroundImage ? `url(${backgroundImage}?format=auto&width=400)` : `url(${defaultImage})`};
  }

  @media (-webkit-min-device-pixel-ratio: 3), (min-resolution: 192dpi) {
    background-image: ${({ backgroundImage }) => backgroundImage ? `url(${backgroundImage}?format=auto&width=600)` : `url(${defaultImage})`};
  }
`;
export const DefaultImageText = styled(Header3) `
  height: 100%;
  width: 95%;
  margin: 0 auto;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: ${SizeAddiFontXxSmall};

  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    font-size: ${SizeAddiFontBase};
  }
`;
export const TitleStore = styled(Header1) `
  margin: 8px 0 4px 0;
  font-size: ${SizeAddiFontXSmall};
  font-weight: ${FontAddiWeightSemiBold};
  line-height: 20.72px;

  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    margin: 12px 0 4px 0;
    line-height: 28.8px;
    font-size: ${SizeAddiFontBase};
    font-weight: ${FontAddiWeightBold};
  }
`;
export const SubTitleStore = styled(Paragraph) `
  margin: 0;
  font-weight: ${FontAddiWeightRegular};
  color: ${ColorAddiGrayBase};
  font-size: ${SizeAddiFontXxSmall};
  line-height: 16.32px;

  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    line-height: 23.68px;
    font-size: ${SizeAddiFontSmall};
  }
`;
export const FavouriteIcon = styled.img `
  width: 20px;
  height: 18px;
  position: relative;
  cursor: pointer;
`;
export const DescriptionContainer = styled.div `
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const TitleContainer = styled.div `
  width: 100%;
`;
//# sourceMappingURL=store-preview.styles.js.map